
// import Video from './video/video.mp4';
import React, {useState, useEffect} from 'react';
import {Redirect, Link} from "react-router-dom";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";


const Biometric = () => {

    

  return (
    <>
    <NavBar/>


    <div class="support-backg">
        <div class="row">
            <div class="col-md-7 mb-5">
                <div class="center">
                    {/* <h2 class="animated fadeIn" id="h2">About Us</h2>
                    <div class="divider"></div> */}
                 </div>
              </div>
              <div class="col-md-5">
                  <div class="skl-mbl-img" id="hide">
                      </div>
                </div>  
              </div>
       </div>

       <div className="container">
        <div className="row pb-5">
            <div className="col-md-1 mt-4"></div>
            <div className="col-md-8">
                <div class="wrapper">
                <h1 className="h1 text-center">BIOMETRIC SOLUTION</h1>
                <p style={{textAlign: "justify"}}>Door access is a critical function of all facilities, whether the purpose is security or safety the need to know who is trying to gain entry or exit from a facility is becoming more important in all businesses.</p>

                <p style={{textAlign: "justify"}}>A key element of all authentication solutions is uniqueness – confirming the ID of the person attempting access or exit.</p>

                <p style={{textAlign: "justify"}}>Passwords are no longer considered secure – biometric authentication is now a prerequisite of many businesses. If biometric authentication is impractical due to the physical constraints/limitations or individual characteristics, then a record of the access event should be supported and recorded (for future verification when needed) with visual images  
                </p>

                </div>
            </div>
            <div className="col-md-4"></div>
        </div>
    </div>


    

    {/* <div className="contain" style={{width:'100%', background:'#fff'}}>
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                            
                    <div className="row pt-5 mb-5">
                            <div className="col-md-12">
                                <img class="d-block w-100" src="../img/partners.png" alt=""/>                   
                            </div>
                        </div>

                </div>
            </div>
        </div>
    </div> */}




     
    <Footer/>




    
    </>
  )
}
export default Biometric;